import { Helmet } from 'react-helmet-async';
import { useShallow } from 'zustand/react/shallow';
// components
import { UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import Drawer from '@/components/Drawer';
import Header from '@/components/Layout/components/Header';
import Filters from '@/pages/Conversations/components/Filters';
import Personas from '@/pages/Conversations/components/Personas';
import Messages from '@/pages/Conversations/components/Messages';
import PersonaDetails from '@/pages/Conversations/components/PersonaDetails';
import URLListener from '@/pages/Conversations/components/URLListener';
// utils
import { cn } from '@/utils';
import useConversationStore from '@/pages/Conversations/Conversations.store.ts';
// assets
import styles from '@/pages/Conversations/Conversations.module.css';

const Conversations = () => {
    const [isOpened, { toggle }] = useDisclosure(true);

    const { selectedUserPersona, personaDetails, togglePersonaDetails } =
        useConversationStore(
            useShallow((state) => ({
                selectedUserPersona: state.selectedUserPersona,
                personaDetails: state.personaDetails,
                togglePersonaDetails: state.togglePersonaDetails
            }))
        );

    return (
        <div className={styles.page}>
            <Helmet>
                <title>NEWO - Conversations</title>
            </Helmet>
            <Header
                breadcrumbs={[{ label: 'Conversations' }]}
                className="gap-4"
            />
            <URLListener />
            <div
                className={cn(styles.wrapper, {
                    [styles.twoCallWrapper]: isOpened
                })}
            >
                <Personas className={styles.personas} />
                <Messages
                    actors={selectedUserPersona?.actors}
                    className={styles.messages}
                />
                <div className={styles.buttonWrapper}>
                    <UnstyledButton
                        className={styles.filterButton}
                        onClick={toggle}
                    >
                        {isOpened ? <ChevronRight /> : <ChevronLeft />}
                    </UnstyledButton>
                </div>
                <div className={styles.filterWrapper}>
                    <Filters />
                </div>
            </div>
            {personaDetails ? (
                <Drawer
                    name="conversations-persona-details"
                    opened={!!personaDetails}
                    position="right"
                    size="md"
                    onClose={() => {
                        togglePersonaDetails();
                    }}
                >
                    <PersonaDetails persona={personaDetails} />
                </Drawer>
            ) : undefined}
        </div>
    );
};

export default Conversations;
